<!--模板界面-->
<template>
	<div class="dyin_right">
		<!--开门次数-->
		<div class="deyin_right_div">
			<vchart ref='demandVchart'></vchart>
		</div>
		<!--近30天电量-->
		<div class="deyin_right_div">
			<vchart ref='thirtyDaysVchart'></vchart>
		</div>
		<!--今日峰平谷-->
		<div class="deyin_right_div" style="height: 48%;">
			<vchart ref='peakVchart'></vchart>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				demandOption: {
					title: {
						text: '开门次数',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						show: false,
						bottom: '3%',
						textStyle: {
							color: "white"
						},
					},
					grid: [{
						bottom: '15%',
						left: '15%',
						height: 120,
					}],
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: { //y轴
							lineStyle: {
								color: 'white',
							}
						},
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: 'white',
								type: 'dashed'
							},
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: [{
						name: '开门次数',
						type: 'bar',
						itemStyle: {
							normal: {
								color: "#2c64ec",
							},
						},
						data: [],

					}, ]
				},
				peakOption: {
					title: {
						text: '今日峰平谷',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					},
					legend: {
						show: false
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					series: [{
						name: '今日峰平谷',
						type: 'pie',
						radius: ['30%', '80%'],
						center: ['50%', '60%'],
						label: {
							normal: {
								show: true,
								position: 'inner',
								textStyle: {
									fontWeight: 100,
									fontSize: 12
								},
								formatter: '{b}:{d}%'

							}
						},
						itemStyle: {
							normal: {
								label: { //此处为指示线文字
									show: false,
									formatter: '{b}:{d}%'
								},
								labelLine: { //指示线状态
									show: true,
									smooth: 0.2,
									length: 1,
									length2: 10
								}
							},
						},
						data: [],
					}]

				},
				thirtyDaysOption: {
					title: {
						text: '近30天数据',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {},
					grid: [{
						bottom: '25%',
						left: '15%',
						height: 120,
					}],
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: { //y轴
							lineStyle: {
								color: 'white',
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: 'white',
								type: 'dashed'
							},
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: [{
						name: '30日用电量',
						type: 'line',
						symbol: 'none',
						itemStyle: {
							normal: {
								color: "#c7ba45",
							},
						},
						data: [],
						areaStyle: {}
					}]

				}
			}
		},
		created() {},
		mounted() {
			this.thirtyDaysOption.xAxis.data = this.monthDay
			this.$refs.demandVchart.setData(this.demandOption)
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			deviceList() {
				return this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos()
			},
			monthDay() {
				//月的每一天
				let list = []
				for(let i = 1; i < 32; i++) {
					if(i < 10) {
						list.push('0' + i)
					} else {
						list.push(i)
					}
				}
				return list
			}
		},
		watch: {},
		methods: {
			initData() {
				let bgTime = new Date(new Date().format("yyyy-MM-dd") + " 00:00:00").getTime()
				let endTime = new Date().getTime()
				//查询峰平谷数据
				this.$api.powerApi.getUnitPG(this.nowUnit.id, bgTime, endTime, respon => {
					let seriesData = []
					respon.forEach(item => {
						if(item.sname == '尖' || item.sname == '峰' || item.sname == '平' || item.sname == '谷') {
							seriesData.push({
								value: item.value,
								name: item.sname
							})
						}
					})
					this.peakOption.series[0].data = seriesData
					this.$refs.peakVchart.setData(this.peakOption)
				})
				//查询30日数据
				this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
					let listData = []
					for(let key in respon) {
						listData.push(respon[key]["总电量"])
					}
					this.thirtyDaysOption.series[0].data = listData
					this.$refs.thirtyDaysVchart.setData(this.thirtyDaysOption)
				})
				//近一七天开门次数
				bgTime = this.getStartDayOfWeek()
				endTime = this.getEndDayOfWeek()
				this.$api.historyApi.unitControlCount(this.nowUnit.id, bgTime, endTime, respon => {
					let seriesData = []
					respon.forEach(item=>{
						seriesData.push(item.dayCount)
					})
					this.demandOption.series[0].data = seriesData
					this.$refs.demandVchart.setData(this.demandOption)
				})
			},
			getStartDayOfWeek() {
				//本周开始时间
				var now = new Date(); // 当前日期
				var nowDayOfWeek = now.getDay(); // 今天本周的第几天
				var nowDay = now.getDate(); // 当前日
				var nowMonth = now.getMonth(); // 当前月
				var nowYear = now.getYear(); // 当前年
				nowYear += (nowYear < 2000) ? 1900 : 0;
				var day = nowDayOfWeek || 7;
				return new Date(now.getFullYear(), nowMonth, nowDay + 1 - day).getTime();
			},
			getEndDayOfWeek() {
				//本周结束时间
				var now = new Date(); // 当前日期
				var nowDayOfWeek = now.getDay(); // 今天本周的第几天
				var nowDay = now.getDate(); // 当前日
				var nowMonth = now.getMonth(); // 当前月
				var nowYear = now.getYear(); // 当前年
				nowYear += (nowYear < 2000) ? 1900 : 0;
				var day = nowDayOfWeek || 7;
				return new Date(now.getFullYear(), nowMonth, nowDay + 7 - day).getTime();
			},
		}
	}
</script>

<style scoped>
	.dyin_right {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}
	
	.dyin_right .default-chart {
		height: 100% !important;
	}
	
	.deyin_right_div {
		width: 100%;
		height: 24%;
		background-image: url(../../../../../public/static/image/科技蓝/deyin/rateBoxBg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	
	.eventTitle {
		font-size: .18rem;
		color: white;
		display: block;
		padding-top: 10px;
		padding-left: 7%;
		font-weight: 800;
	}
	
	.powerProgress {
		width: 90%;
		margin: 0 auto;
		margin-top: 2%;
	}
	
	.powerProgress p {
		color: white;
		line-height: 30px;
	}
	
	.powerProgress p span {
		color: #f29700;
		font-size: 20px;
		padding: 0 5px;
	}
</style>
<style>
	#powerProgress1 .el-progress-bar__inner {
		background-color: #f29700;
	}
</style>